import * as wjcCore from 'wijmo/wijmo';
// angular
import {Injectable} from '@angular/core';

// libs
import {Store, Action} from '@ngrx/store';
import {Effect, Actions, ofType} from '@ngrx/effects';
import {map, switchMap} from "rxjs/internal/operators";
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';

import {KaitoriyaConfig} from "../../config/kaitoriya.config";

// module
import {DataService} from '@cosbeni/database';
import {ActionTypes, LoadUserSuccessAction, LoadUserFailureAction} from "../actions/user.action";
import {Router} from "@angular/router";

@Injectable()
export class UserEffects {

    @Effect() loadUser$: Observable<Action> = this.actions$.pipe(
        ofType(ActionTypes.LOAD_USER),
        switchMap(() => {
            let url = KaitoriyaConfig.SERVER_URL;
            let tokenName = KaitoriyaConfig.DATABASE + "_token";
            return this.dataService.user({}, url).map((response) => {
                let user = response;
                return new LoadUserSuccessAction(user);
            }).catch(() => {
                    this.router.navigate(["login"], {})
                    return Observable.of(new LoadUserFailureAction())
                }
            );
        })
    )

    constructor(private store: Store<any>,
                private actions$: Actions,
                private dataService: DataService,
                private router: Router) {
    }
}
